import React from 'react';
import styles from "./styles.module.scss"
import { ReactComponent as BackArrow } from "../../../../../../assets/img/svg/BackArrow.svg";
import IconButtonWrapper from '../../../common/form-fields-mui/IconButtonWrapper';
import AButton from '../../../common/form-fields-mui/AButton';
import { useHistory } from "react-router-dom"

const EmprConfigHeaderCard = ({
    addConfigHandler,
    isCreatePermission,
    heading = 'EPMR Configs',
    filters = null,
    isConfig = true,
    headingClassName=''
}) => {

    const history = useHistory();

    return (
        <div className={styles['header-card'] + " d-flex justify-content-between"}>

            <div>
                <IconButtonWrapper>
                    <BackArrow onClick={() => history.goBack()} />
                </IconButtonWrapper>
                <h4 className={`d-inline ${headingClassName}`}>{heading}</h4>
            </div>

            <div className='d-inline-flex'>
                {filters}
                {isConfig && <AButton
                    variant='primary_filled'
                    size='xs'
                    className='mt-1'
                    onClick={addConfigHandler}
                    disabled={!isCreatePermission}
                >
                    Add Config
                </AButton>
                }
            </div>
        </div>
    );
}

export default EmprConfigHeaderCard;